module.exports = __webpack_public_path__ + "img/onl.1e1142f1.svg";